// @ts-nocheck
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { EntityFieldsComponent } from '../../dynamic-form/sub-modules/sub-form/entity-fields/entity-fields.component';
import { DatePickerComponent } from '../date-picker/date-picker.component';
import { DateTimePickerComponent } from '../date-time-picker/date-time-picker.component';
import { InputHiddenComponent } from '../input-hidden/input-hidden.component';
import { InputTextComponent } from '../input-text/input-text.component';

@Component({
  selector: 'lbca-additional-values',
  templateUrl: './additional-values.component.html',
  styleUrl: './additional-values.component.scss',
  imports: [
    NgClass,
    InputHiddenComponent,
    InputTextComponent,
    forwardRef(() => EntityFieldsComponent),
    DatePickerComponent,
    DateTimePickerComponent,
    NgTemplateOutlet,
  ],
})
export class AdditionalValuesComponent implements OnInit {
  public fields!: any;
  public isDisabled: boolean = false;
  public data: any = {};

  @Input('field') set fieldList(fields: any) {
    this.fields = fields;
  }

  @Input() set disabled(item: any) {
    this.isDisabled = item;
  }

  @Input() set value(value: any) {
    const val = value.length ? value[0] : value;
    this.data = val;
  }

  public cardInfo!: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  @Output('changeValue') changeValueEmitter = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    setTimeout(() => {
      this.fields.forEach((group, index) => {
        group.enabled = false;
        group.filled = false;
        if (index === 0) group.enabled = true;
        group.fields.forEach((field) => {
          field.forEach((item) => {
            //if (this.data)
            item.value = this.data[item.entityKey];

            if (item.value) group.enabled = true;

            // item.disabled = !group.enabled;
          });
        });
      });

      //this.requireFields(this.fields[0])
    }, 200);
  }

  changeFieldValue($event, entityKey) {
    /** não sei o porque desse timeOut , foi retirado pois estava dando problema
     * na troca dos valores e ficava piscando o campo
     */
    /*
      setTimeout( () => {
        this.changeValueEmitter.emit({value: $event, entityKey})
      },10)*/

    this.changeValueEmitter.emit({ value: $event, entityKey });

    setTimeout(() => {
      this.fields.forEach((group) => {
        group.filled = true;
        group.fields.forEach((field) => {
          field.forEach((item) => {
            if (item.required && !item.value) group.filled = false;
          });
        });
      });
    }, 200);
  }

  // toogle(f){return;}
  toogle(field) {
    field.enabled = !field.enabled;

    this.changeValueEmitter.emit({ value: field.enabled, entityKey: field.entityKey });

    if (field.enabled) {
      //open
      setTimeout(() => {
        const element = document.querySelector('#' + field.label);
        if (element) {
          const topPos = element.getBoundingClientRect().top || 0;
          const modal = document.querySelector('.modal-content');
          if (modal) {
            modal!.scroll({
              top: topPos,
              behavior: 'smooth',
            } as any);
          }
        }
      }, 200);

      this.requireFields(field);
    } else {
      this.clearValuesFields(field);
    }
  }

  private clearValuesFields(mainField) {
    const require = mainField.required;
    mainField.fields.forEach((row: any) => {
      row.forEach((field) => {
        field.required = require;
        field.value = null;
        this.changeValueEmitter.emit({
          value: null,
          entityKey: field.entityKey,
          required: field.required,
        });
      });
    });
  }

  private requireFields(mainField) {
    const require = mainField.required;
    mainField.fields.forEach((row: any) => {
      row.forEach((field) => {
        field.required = require;
        this.changeValueEmitter.emit({ entityKey: field.entityKey, required: field.required });
      });
    });
  }
}
